
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/rankings",
      function () {
        return require("private-next-pages/sitemap/rankings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/rankings"])
      });
    }
  